import './index.css';
import { useMemo, useState, useRef, useCallback, useEffect } from 'react';

const areEqualArrays = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    const sortArr2 = arr2.slice().sort();
    return arr1
        .slice()
        .sort()
        .every((item, index) => item === sortArr2[index]);
};
const calculateInitialExpanded = (initialExpanded, selected, expandTreeOnSelected, collection) => {
    let expanded = initialExpanded.slice();
    if (expandTreeOnSelected) {
        expanded = selected.reduce((acc, id) => {
            return acc.concat(collection.getParentIds(id));
        }, expanded);
    }
    return [...new Set(expanded)];
};
const useExpanded = ({ initialValue, selected, expandTreeOnSelected, collection, onExpand, }) => {
    const calculatedInitialValue = useMemo(() => calculateInitialExpanded(initialValue, selected, expandTreeOnSelected, collection), 
    // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    []);
    const [expanded, setExpanded] = useState(calculatedInitialValue);
    const expandedRef = useRef(calculatedInitialValue);
    const selectedRef = useRef(selected);
    selectedRef.current = selected;
    const handlerRef = useRef(onExpand);
    const handleSetExpanded = useCallback((updatedExpanded) => {
        handlerRef.current?.(updatedExpanded.slice());
        if (!areEqualArrays(expandedRef.current, updatedExpanded)) {
            setExpanded(updatedExpanded);
        }
    }, []);
    const handleExpansion = useCallback((id) => {
        let updatedExpanded;
        if (expandedRef.current.includes(id)) {
            updatedExpanded = expandedRef.current.filter((itemId) => itemId !== id);
        }
        else {
            updatedExpanded = expandedRef.current.slice();
            updatedExpanded.push(id);
        }
        handleSetExpanded(updatedExpanded);
    }, [handleSetExpanded]);
    const handleResetExpanded = useCallback(() => {
        const calculatedResetValue = calculateInitialExpanded(initialValue, selectedRef.current, expandTreeOnSelected, collection);
        if (!areEqualArrays(expandedRef.current, calculatedResetValue)) {
            setExpanded(calculatedResetValue);
        }
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        handlerRef.current = onExpand;
    }, [onExpand]);
    useEffect(() => {
        expandedRef.current = expanded;
    }, [expanded]);
    return { expanded, setExpanded: handleSetExpanded, handleExpansion, handleResetExpanded };
};

export { areEqualArrays, calculateInitialExpanded, useExpanded };
//# sourceMappingURL=useExpanded.js.map
